import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    fontFamily: 'Open Sans',
    fontWeight: 'normal',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#F0F0F0'
  },
  pagePadding: {
    padding: '0 36px'
  },
  banner: {
    display: 'flex',
    position: 'absolute',
    bottom: 25,
    left: 0,
    right: 0,
    height: '16%',
    width: '100%',
    backgroundColor: 'rgba(80,80,81)',
    opacity: 0.87
  },
  bannerContent: {
    flex: '1',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 30px'
  },
  firstBanner: {
    justifyContent: 'flex-end'
  },
  greenBulletPoint: {
    width: '5px',
    height: '100%',
    backgroundColor: 'rgba(188,207,29)',
    marginRight: '10px'
  },
  introPageSubtitleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center'
  },
  introPageSubtitle: {
    fontSize: '18px',
    fontWeight: 'bold'
  },
  introPageContent: {
    marginTop: '5px',
    fontSize: '12px'
  },
  toc: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tocEntry: {
    marginLeft: 30,
    fontSize: 17,
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
    width: '50%'
  },
  tocLink: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    textDecoration: 'none',
    color: '#000'
  },
  tocTitle: {
    flex: 1
  },
  tocPageNumber: {
    width: 30,
    textAlign: 'right'
  },
  logo: {
    position: 'absolute',
    top: 20,
    right: 0,
    width: 153,
    height: 26
  },
  lineContainer: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    borderTop: '1px solid grey',
    width: '90%',
    alignSelf: 'center',
    paddingTop: '5px'
  },
  footer: {
    textAlign: 'center',
    color: 'grey',
    fontSize: 12
  },
  header: {
    position: 'absolute',
    fontSize: 26,
    fontWeight: 'bold',
    top: 20,
    left: 20,
    right: 0
  },
  tilesContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexDirection: 'row'
  },
  tileContainer: {
    height: '400px'
  },
  backgroundImage: {
    position: 'absolute',
    height: '100%',
    width: '100%'
  },
  noLinkStyle: {
    textDecoration: 'none',
    color: '#fff'
  }
});
